import React from "react";

import {
  avatarBase,
  getAvatarAsset,
} from "./avatarConfig";

const AvatarPreview = ({
  avatar,
  className = "",
}) => {
  if (!avatar) {
    return null;
  }

  const face = getAvatarAsset(
    "face",
    avatar.face
  );

  const hair = getAvatarAsset(
    "hair",
    avatar.hair
  );

  const clothes = getAvatarAsset(
    "clothes",
    avatar.clothes
  );

  const glasses = getAvatarAsset(
    "glasses",
    avatar.glasses
  );

  const accessories = getAvatarAsset(
    "accessories",
    avatar.accessories
  );

  const background = getAvatarAsset(
    "background",
    avatar.background
  );

  return (
    <div
      className={`avatar-preview ${className}`}
      style={{
        backgroundColor:
          background?.color || "#d6f2fe",
      }}
    >
      <img
        src={avatarBase}
        alt="Avatar"
        className="avatar-layer avatar-base"
      />

      {clothes && (
        <img
          src={clothes.image}
          alt=""
          className="avatar-layer avatar-clothes"
        />
      )}

      {face && (
        <img
          src={face.image}
          alt=""
          className="avatar-layer avatar-face"
        />
      )}

      {hair && (
        <img
          src={hair.image}
          alt=""
          className="avatar-layer avatar-hair"
        />
      )}

      {glasses && (
        <img
          src={glasses.image}
          alt=""
          className="avatar-layer avatar-glasses"
        />
      )}

      {accessories && (
        <img
          src={accessories.image}
          alt=""
          className="avatar-layer avatar-accessories"
        />
      )}
    </div>
  );
};

export default AvatarPreview;